var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcelas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.229 11.152h-8.381v-8.38a.188.188 0 00-.188-.188h-.61a9.342 9.342 0 00-6.62 2.742 9.328 9.328 0 00-2.742 6.623A9.341 9.341 0 003.43 18.57c.86.86 1.86 1.535 2.976 2.007 1.154.489 2.394.74 3.647.738a9.342 9.342 0 006.621-2.742 9.316 9.316 0 002.006-2.977c.49-1.153.74-2.394.739-3.647v-.61a.192.192 0 00-.19-.187zm2.06-1.3l-.06-.661a9.303 9.303 0 00-2.698-5.726A9.34 9.34 0 0012.79.772L12.127.71a.186.186 0 00-.204.185V9.89c0 .103.085.188.188.188l8.99-.024a.188.188 0 00.188-.201z",
    fill: "#fff"
  })));
}
export default SvgParcelas;